<template>
	<div class="mainContentBackground mapBackground unselectable">
		<div id="map" class="mapContainer">
			<div class="sidebar zoomBar">
				<div class="mainLayoutMenuButton directionTo withArrowTip zoomButton zoomIn clickable" :class="{disabled: zoomLevel >= zoomMaxLevel}" content="Приблизить" v-tippy="{placement: 'right'}" @click="onZoomIn()">
					<i class="action_zoomIn_small_flat_black"></i>
				</div>
				<div class="mainLayoutMenuButton directionTo withArrowTip zoomButton zoomOut clickable" :class="{disabled: zoomLevel <= zoomMinLevel}" content="Отдалить" v-tippy="{placement: 'right'}" @click="onZoomOut()">
					<i class="action_zoomOut_small_flat_black"></i>
				</div>
				<div class="zoomLevel">
					<i class="currentZoomLevel" :class="['sideMenu_zoomLevel'+zoomLevel+'_small_flat_black']"></i>
				</div>
				<div :class="['mainLayoutMenuButton', 'directionTo', 'filterButton', {active: filters.showFilters}]">
					<div class="buttonWrapper clickable" @click="filters.showFilters = !filters.showFilters" content="Фильтр" v-tippy="{placement: 'right'}">
						<i class="sideMenu_filter_small_flat_black"></i>
					</div>
					<div class="filters" v-if="filters.showFilters">
						<div class="content">
							<div>
								<div class="headline"><span>Фильтр карты</span></div>
								<div class="option">
									<label class="clickInputLabel">
										<div class="clickInputWrapper">
											<input type="checkbox" class="ng-pristine ng-untouched ng-valid" />
											<i class="action_check_tiny_flat_black"></i>
										</div>
										<span><span>Границы королевств</span></span>
									</label>
								</div>
								<div class="option">
									<label class="clickInputLabel">
										<div class="clickInputWrapper">
											<input type="checkbox" class="ng-pristine ng-untouched ng-valid" />
											<i class="action_check_tiny_flat_black"></i>
										</div>
										<span><span>Свои маркеры</span></span>
									</label>
								</div>
								<div class="option">
									<label class="clickInputLabel">
										<div class="clickInputWrapper">
											<input type="checkbox" class="ng-pristine ng-untouched ng-valid" />
											<i class="action_check_tiny_flat_black"></i>
										</div>
										<span><span>Столицы</span></span>
									</label>
								</div>
								<div class="option">
									<label class="clickInputLabel">
										<div class="clickInputWrapper">
											<input type="checkbox" class="ng-pristine ng-untouched ng-valid" />
											<i class="action_check_tiny_flat_black"></i>
										</div>
										<span><span>Системные сообщения</span></span>
									</label>
								</div>
								<div class="option">
									<label class="clickInputLabel">
										<div class="clickInputWrapper">
											<input type="checkbox" class="ng-pristine ng-untouched ng-valid" />
											<i class="action_check_tiny_flat_black"></i>
										</div>
										<span><span>Сообщения игроков</span></span>
									</label>
								</div>
								<div class="option">
									<label class="clickInputLabel">
										<div class="clickInputWrapper">
											<input type="checkbox" class="ng-pristine ng-untouched ng-valid" />
											<i class="action_check_tiny_flat_black"></i>
										</div>
										<span><span>Сокровища</span></span>
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div :class="['mainLayoutMenuButton', 'directionTo', 'goToButton', {'active': goToLocation.show}]">
					<div class="buttonWrapper clickable" @click="goToLocation.show = !goToLocation.show" content="Перейти к местности" v-tippy="{placement: 'right'}">
						<i class="sideMenu_goTo_small_flat_black"></i>
					</div>
					<div class="filters" v-if="goToLocation.show">
						<div class="content">
							<div class="header">
								<span><span>Перейти к местности</span></span>
							</div>
							<span class="serverautocompleteContainer ng-valid">
								<span role="status" class="ui-helper-hidden-accessible"></span>
								<input class="targetInput ng-pristine ng-untouched ng-valid ui-autocomplete-input" type="text" autocomplete="off" placeholder="Поиск..." />
								<label style="width: 101px;">
									<i class="action_search_tiny_flat_white"></i>
									Деревня, Игрок, Название королевства, Координаты
								</label>
							</span>
							<i class="centerResult clickable symbol_target_small_flat_black ng-hide" ng-class="{symbol_target_small_flat_black: !targetHover, symbol_target_small_flat_green: targetHover}" on-pointer-over="targetHover = true" on-pointer-out="targetHover = false" clickable="goToLocation.jump(true)" ng-show="goToLocation.searchObj.data.length > 0"></i>
							<div class="footer" ng-show="goToLocation.searchObj.data.length > 1">
								<span><span>Совпадений: 1 из </span></span>
								<span class="arrowButtonContainer">
									<a class="arrowButton clickable disabled" clickable="goToLocation.backward()" ng-class="{disabled: goToLocation.index <= 1}" on-pointer-over="fromHover = true" on-pointer-out="fromHover = false">
										<i ng-class="{
											symbol_arrowFrom_tiny_flat_black: !fromHover || goToLocation.index <= 1,
											symbol_arrowFrom_tiny_flat_green: fromHover && goToLocation.index > 1
										}" class="symbol_arrowFrom_tiny_flat_black"></i>
									</a>
									<a class="arrowButton clickable" clickable="goToLocation.forward()" ng-class="{disabled: goToLocation.index == goToLocation.searchObj.data.length}" on-pointer-over="toHover = true" on-pointer-out="toHover = false">
										<i ng-class="{
											symbol_arrowTo_tiny_flat_black: !toHover || (goToLocation.index == goToLocation.searchObj.data.length),
											symbol_arrowTo_tiny_flat_green: toHover && (goToLocation.index != goToLocation.searchObj.data.length)
										}" class="symbol_arrowTo_tiny_flat_black"></i>
									</a>
								</span>
							</div>
						</div>
					</div>
				</div>
				<div class="mainLayoutMenuButton directionTo goHomeButton" content="Перейти к открытой деревне" v-tippy="{placement: 'right'}" @click="onGotoOpenIsland()">
					<i class="symbol_target_small_flat_black clickable"></i>
				</div>
			</div>
			<!--<div id="overlayMarkers" class="zoomLevel1" style="top: -645px; left: 1260px;">-->
			<div id="overlayMarkers" class="zoomLevel1" style="top: 469px; left: 958px;">
				<div class="clouds tutorial_mapOverlay_illustration" id="tutorialClouds" v-if="gameModel.player.spawnedOnMap == 0">
					<div class="extraCover side1 tutorial_mapOverlayStart_illustration" :class="{invisible: gameModel.islands.length > 0}"></div>
					<div class="extraCover side2 tutorial_mapOverlayEnd_illustration" :class="{invisible: gameModel.islands.length > 0}"></div>
				</div>
			</div>
			<div id="tileInformation" class="contentBox unselectable" :class="{coordsOnly: tiInfos.coordsOnly}" v-if="tiInfos.coord">
				<div class="contentBoxHeader">
					<span class="coordinates">
						<span class="coordinateWrapper" nolink="true" aligned="false">
							<span ng-if="!hasLink" class="coordinates coordinatesWrapper" ng-bind-html="coord | bidiCoordinate:x:y">
								<span class="coordinateX">({{tiInfos.coord.x}}</span>
								<span class="coordinatePipe">|</span>
								<span class="coordinateY">{{tiInfos.coord.y}})</span>
							</span>
						</span>
					</span>
					<span v-if="tiInfos.villageName" class="villageName truncated">{{tiInfos.villageName}}</span>
					<div class="additionalInfo iconValueList">
						<div v-if="tiInfos.population">
							<span><i class="unit_population_small_illu"></i></span>
						</div>
						<div v-if="tiInfos.oasisBonus">
							<span v-for="(bonus, resType) in tiInfos.oasisBonus" :key="resType">
								<i :class="['unit_'+resType+'_small_illu']"></i>{{bonus}}%
							</span>
						</div>
					</div>
					<span class="mainVillageIndicator" v-if="tiInfos.isMainVillage">
						<i class="village_main_small_flat_black"></i>
					</span>
				</div>
				<div class="contentBoxBody resources unselectable" v-if="tiInfos.resDistribution || tiInfos.robberVillageDetails || tiInfos.oasis || tiInfos.playerName">
					<span v-if="tiInfos.oasisDetails && tiInfos.oasis.oasisStatus == 'Village.OASIS_STATUS_WILD'">
						<span class="unit" v-for="animal in tiInfos.oasisDetails.filteredTroops">
							<i class="unitSmall nature" :class="['unitType'+animal.unitType]" unit-icon="" :data="'4, '+animal.unitType"></i>{{animal.count}}&nbsp;
						</span>
					</span>
					<span v-if="tiInfos.robberVillageDetails">
						<span class="unit" v-for="troop in tiInfos.robberVillageDetails.filteredTroops">
							<i class="unitSmall gaul" :class="['unitType'+troop.unitType]" unit-icon="" :data="'3, '+troop.unitType"></i>{{troop.count}}&nbsp;
						</span>
					</span>
					<span v-if="tiInfos.resDistribution">
						<i class="unit_wood_small_illu"></i>{{tiInfos.resDistribution.wood}}
						<i class="unit_clay_small_illu"></i>{{tiInfos.resDistribution.clay}}
						<i class="unit_iron_small_illu"></i>{{tiInfos.resDistribution.iron}}
						<i class="unit_crop_small_illu"></i>{{tiInfos.resDistribution.crop}}
					</span>
					<span class="owner">
						<span v-if="tiInfos.oasis && tiInfos.oasis.oasisStatus == 'Village.OASIS_STATUS_OCCUPIED'">
							<i class="community_kingdom_small_flat_black"></i>
							<a :class="{disabled: kingdomId <= 0 || nolink}" class="disabled kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 48}, null, true)" kingdomid="48" nolink="true">{{kingdomName}}</a>
						</span>
						<span v-if="multiLanguageServer && tiInfos.country" :class="[tiInfos.country]" class="languageFlag"></span>
						<span v-if="tiInfos.playerName">
							<span class="truncated">{{tiInfos.playerName}}</span>
						</span>
					</span>
				</div>
				<div class="reportsContainer unselectable" ng-if="tiInfos.report">
					<div class="reportsDecoration unselectable">
						<!--
						<span class="inner">
							<i class="reportIcon reportTypes_reportIcon4"></i>
							<span i18ndt="1705294777" format="veryShort">15.01. | 10:59</span>
						</span>
						<span class="inner">
							<i class="reportIcon reportTypes_reportIcon19"></i>
							<span i18ndt="1708109004" format="veryShort">00:43</span>
						</span>
						-->
						<span class="inner">
							<i class="reportIcon reportTypes_reportIcon6"></i>
							<span i18ndt="1705351034" format="veryShort">16.01. | 02:37</span>
							<span ng-if="tiInfos.report && tiInfos.report.capacity > 0" class="carry">
								<i ng-class="{
									unit_capacityEmpty_small_flat_black: tiInfos.report.raidedResSum == 0,
									unit_capacityHalf_small_flat_black: tiInfos.report.raidedResSum > 0 && tiInfos.report.raidedResSum < tiInfos.report.capacity,
									unit_capacity_small_flat_black: tiInfos.report.raidedResSum == tiInfos.report.capacity
								}" class="unit_capacity_small_flat_black"></i>
								2355/2355
							</span>
						</span>
					</div>
				</div>
			</div>
			<div class="infoMovements unselectable" ng-style="tiStyle" style="visibility: visible;">
				<ul class="troopMovements" ng-if="zoomLevel != 2">
					<li class="small infoMovementType incoming unselectable incoming_attacks" ng-repeat="(type, info) in tiInfos.movements">
						<i class="movement_attack_small_flat_black"></i>
						<div class="countdown" countdown="1708165984">00:05:12</div>
						<div class="count">1</div>
						<div class="ending">
							<div class="colored"></div>
						</div>
					</li>
					<li class="small infoMovementType incoming unselectable return" ng-repeat="(type, info) in tiInfos.movements">
						<i class="movement_support_small_flat_black"></i>
						<div class="countdown" countdown="1708156183.281573">00:15:45</div>
						<div class="count">1</div>
						<div class="ending">
							<div class="colored"></div>
						</div>
					</li>
					<li class="small infoMovementType incoming unselectable return" ng-repeat="(type, info) in tiInfos.movements">
						<i class="movement_support_small_flat_black"></i>
						<div class="countdown" countdown="1708158063">00:47:05</div>
						<div class="count">1</div>
						<div class="ending">
							<div class="colored"></div>
						</div>
					</li>
				</ul>
			</div>
			<div class="infoMovements unselectable" style="visibility: hidden;">
				<ul class="troopMovements"></ul>
			</div>
			<div id="canvasBorder" class="map-container" style="position: absolute; top: 0px; left: 0px; overflow: hidden; width: 100%; height: 100%; cursor: pointer;">
				
			</div>
		</div>
	</div>
	
	
	
	<!--
	<div class="mainContentBackground mapBackground unselectable">
		<div id="map" class="mapContainer">
			<div id="canvasBorder" style="position: absolute; top: 0px; left: 0px; overflow: hidden; width: 1263px; height: 750px;">
				<div id="canvasMap" width="1515" height="886" style="position: absolute; top: -68px; left: -126px;">
					<div v-for="x in range(min, max)" class="cnt">
						<div v-for="y in range(min, max)" style="display: inline-block;" :class="[
							'bl',
							{'empty': map[x][y].idIsland == null && map[x][y].idUser == null},
							{'user': map[x][y].idIsland != null && map[x][y].idUser != null},
							{'barbarian': map[x][y].idIsland != null && map[x][y].idUser == null},
							{'selected': (x == action.x1 && y == action.y1) || (x == action.x2 && y == action.y2)},
							{'moveto': map[x][y].idIsland == null && map[x][y].idUser == null && action.moving}
						]" :title="x+' | '+y+(map[x][y].name ? ' ('+map[x][y].name+')' : '')+(map[x][y].username ? ' ('+map[x][y].username+')' : '')" @click="move(x, y)"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
	-->
</template>

<style lang="scss">
$color_1: #fff;
$color_2: #5a534b;
$color_3: #777;
$color_4: #252525;
$background-color_1: rgba(241,240,238,0.7);
$background-color_2: rgba(241,240,238,0.6);
$background-color_3: rgba(255,255,255,0.7);
$background-color_4: rgba(235,235,235,0.85);
$background-color_5: rgba(70,63,57,0.85);
$background-color_6: rgba(253,241,95,0.85);
$background-color_7: #fff;
$background-color_8: #e9e5e2;
$background-color_9: #e8e5e1;
$background-color_10: rgba(235,235,235,0.5);
$background-color_11: rgba(255,255,255,0.85);
$border-color_1: transparent transparent #463f39 #463f39;

@-webkit-keyframes outgoingAttack {
	from {
		background-position: -1200px -1700px;
	}
	5% {
		background-position: -1890px -500px;
	}
	10% {
		background-position: -1890px -700px;
	}
	15% {
		background-position: -1890px -800px;
	}
	20% {
		background-position: -1890px -900px;
	}
	25% {
		background-position: -1890px -1000px;
	}
	30% {
		background-position: -1890px -1100px;
	}
	35% {
		background-position: -1890px -1200px;
	}
	40% {
		background-position: -1890px -1300px;
	}
	45% {
		background-position: -1300px -1700px;
	}
	50% {
		background-position: -1400px -1700px;
	}
	55% {
		background-position: -1500px -1700px;
	}
	60% {
		background-position: -1600px -1700px;
	}
	65% {
		background-position: -1700px -1700px;
	}
	70% {
		background-position: -1890px 0;
	}
	75% {
		background-position: -1890px -100px;
	}
	80% {
		background-position: -1890px -200px;
	}
	85% {
		background-position: -1890px -300px;
	}
	90% {
		background-position: -1890px -400px;
	}
	95% {
		background-position: -1890px -600px;
	}
}
@-moz-keyframes outgoingAttack {
	from {
		background-position: -1200px -1700px;
	}
	5% {
		background-position: -1890px -500px;
	}
	10% {
		background-position: -1890px -700px;
	}
	15% {
		background-position: -1890px -800px;
	}
	20% {
		background-position: -1890px -900px;
	}
	25% {
		background-position: -1890px -1000px;
	}
	30% {
		background-position: -1890px -1100px;
	}
	35% {
		background-position: -1890px -1200px;
	}
	40% {
		background-position: -1890px -1300px;
	}
	45% {
		background-position: -1300px -1700px;
	}
	50% {
		background-position: -1400px -1700px;
	}
	55% {
		background-position: -1500px -1700px;
	}
	60% {
		background-position: -1600px -1700px;
	}
	65% {
		background-position: -1700px -1700px;
	}
	70% {
		background-position: -1890px 0;
	}
	75% {
		background-position: -1890px -100px;
	}
	80% {
		background-position: -1890px -200px;
	}
	85% {
		background-position: -1890px -300px;
	}
	90% {
		background-position: -1890px -400px;
	}
	95% {
		background-position: -1890px -600px;
	}
}
@-ms-keyframes outgoingAttack {
	from {
		background-position: -1200px -1700px;
	}
	5% {
		background-position: -1890px -500px;
	}
	10% {
		background-position: -1890px -700px;
	}
	15% {
		background-position: -1890px -800px;
	}
	20% {
		background-position: -1890px -900px;
	}
	25% {
		background-position: -1890px -1000px;
	}
	30% {
		background-position: -1890px -1100px;
	}
	35% {
		background-position: -1890px -1200px;
	}
	40% {
		background-position: -1890px -1300px;
	}
	45% {
		background-position: -1300px -1700px;
	}
	50% {
		background-position: -1400px -1700px;
	}
	55% {
		background-position: -1500px -1700px;
	}
	60% {
		background-position: -1600px -1700px;
	}
	65% {
		background-position: -1700px -1700px;
	}
	70% {
		background-position: -1890px 0;
	}
	75% {
		background-position: -1890px -100px;
	}
	80% {
		background-position: -1890px -200px;
	}
	85% {
		background-position: -1890px -300px;
	}
	90% {
		background-position: -1890px -400px;
	}
	95% {
		background-position: -1890px -600px;
	}
}
@-o-keyframes outgoingAttack {
	from {
		background-position: -1200px -1700px;
	}
	5% {
		background-position: -1890px -500px;
	}
	10% {
		background-position: -1890px -700px;
	}
	15% {
		background-position: -1890px -800px;
	}
	20% {
		background-position: -1890px -900px;
	}
	25% {
		background-position: -1890px -1000px;
	}
	30% {
		background-position: -1890px -1100px;
	}
	35% {
		background-position: -1890px -1200px;
	}
	40% {
		background-position: -1890px -1300px;
	}
	45% {
		background-position: -1300px -1700px;
	}
	50% {
		background-position: -1400px -1700px;
	}
	55% {
		background-position: -1500px -1700px;
	}
	60% {
		background-position: -1600px -1700px;
	}
	65% {
		background-position: -1700px -1700px;
	}
	70% {
		background-position: -1890px 0;
	}
	75% {
		background-position: -1890px -100px;
	}
	80% {
		background-position: -1890px -200px;
	}
	85% {
		background-position: -1890px -300px;
	}
	90% {
		background-position: -1890px -400px;
	}
	95% {
		background-position: -1890px -600px;
	}
}
@keyframes outgoingAttack {
	from {
		background-position: -1200px -1700px;
	}
	5% {
		background-position: -1890px -500px;
	}
	10% {
		background-position: -1890px -700px;
	}
	15% {
		background-position: -1890px -800px;
	}
	20% {
		background-position: -1890px -900px;
	}
	25% {
		background-position: -1890px -1000px;
	}
	30% {
		background-position: -1890px -1100px;
	}
	35% {
		background-position: -1890px -1200px;
	}
	40% {
		background-position: -1890px -1300px;
	}
	45% {
		background-position: -1300px -1700px;
	}
	50% {
		background-position: -1400px -1700px;
	}
	55% {
		background-position: -1500px -1700px;
	}
	60% {
		background-position: -1600px -1700px;
	}
	65% {
		background-position: -1700px -1700px;
	}
	70% {
		background-position: -1890px 0;
	}
	75% {
		background-position: -1890px -100px;
	}
	80% {
		background-position: -1890px -200px;
	}
	85% {
		background-position: -1890px -300px;
	}
	90% {
		background-position: -1890px -400px;
	}
	95% {
		background-position: -1890px -600px;
	}
}
@-webkit-keyframes outgoingSupport {
	from {
		background-position: 0 -1600px;
	}
	5% {
		background-position: -700px -1800px;
	}
	10% {
		background-position: -900px -1800px;
	}
	15% {
		background-position: -1000px -1800px;
	}
	20% {
		background-position: -1100px -1800px;
	}
	25% {
		background-position: -1200px -1800px;
	}
	30% {
		background-position: -1300px -1800px;
	}
	35% {
		background-position: -1400px -1800px;
	}
	40% {
		background-position: -1500px -1800px;
	}
	45% {
		background-position: -1890px -1500px;
	}
	50% {
		background-position: -1890px -1600px;
	}
	55% {
		background-position: -1890px -1700px;
	}
	60% {
		background-position: 0 -1800px;
	}
	65% {
		background-position: -100px -1800px;
	}
	70% {
		background-position: -200px -1800px;
	}
	75% {
		background-position: -300px -1800px;
	}
	80% {
		background-position: -400px -1800px;
	}
	85% {
		background-position: -500px -1800px;
	}
	90% {
		background-position: -600px -1800px;
	}
	95% {
		background-position: -800px -1800px;
	}
}
@-moz-keyframes outgoingSupport {
	from {
		background-position: 0 -1600px;
	}
	5% {
		background-position: -700px -1800px;
	}
	10% {
		background-position: -900px -1800px;
	}
	15% {
		background-position: -1000px -1800px;
	}
	20% {
		background-position: -1100px -1800px;
	}
	25% {
		background-position: -1200px -1800px;
	}
	30% {
		background-position: -1300px -1800px;
	}
	35% {
		background-position: -1400px -1800px;
	}
	40% {
		background-position: -1500px -1800px;
	}
	45% {
		background-position: -1890px -1500px;
	}
	50% {
		background-position: -1890px -1600px;
	}
	55% {
		background-position: -1890px -1700px;
	}
	60% {
		background-position: 0 -1800px;
	}
	65% {
		background-position: -100px -1800px;
	}
	70% {
		background-position: -200px -1800px;
	}
	75% {
		background-position: -300px -1800px;
	}
	80% {
		background-position: -400px -1800px;
	}
	85% {
		background-position: -500px -1800px;
	}
	90% {
		background-position: -600px -1800px;
	}
	95% {
		background-position: -800px -1800px;
	}
}
@-ms-keyframes outgoingSupport {
	from {
		background-position: 0 -1600px;
	}
	5% {
		background-position: -700px -1800px;
	}
	10% {
		background-position: -900px -1800px;
	}
	15% {
		background-position: -1000px -1800px;
	}
	20% {
		background-position: -1100px -1800px;
	}
	25% {
		background-position: -1200px -1800px;
	}
	30% {
		background-position: -1300px -1800px;
	}
	35% {
		background-position: -1400px -1800px;
	}
	40% {
		background-position: -1500px -1800px;
	}
	45% {
		background-position: -1890px -1500px;
	}
	50% {
		background-position: -1890px -1600px;
	}
	55% {
		background-position: -1890px -1700px;
	}
	60% {
		background-position: 0 -1800px;
	}
	65% {
		background-position: -100px -1800px;
	}
	70% {
		background-position: -200px -1800px;
	}
	75% {
		background-position: -300px -1800px;
	}
	80% {
		background-position: -400px -1800px;
	}
	85% {
		background-position: -500px -1800px;
	}
	90% {
		background-position: -600px -1800px;
	}
	95% {
		background-position: -800px -1800px;
	}
}
@-o-keyframes outgoingSupport {
	from {
		background-position: 0 -1600px;
	}
	5% {
		background-position: -700px -1800px;
	}
	10% {
		background-position: -900px -1800px;
	}
	15% {
		background-position: -1000px -1800px;
	}
	20% {
		background-position: -1100px -1800px;
	}
	25% {
		background-position: -1200px -1800px;
	}
	30% {
		background-position: -1300px -1800px;
	}
	35% {
		background-position: -1400px -1800px;
	}
	40% {
		background-position: -1500px -1800px;
	}
	45% {
		background-position: -1890px -1500px;
	}
	50% {
		background-position: -1890px -1600px;
	}
	55% {
		background-position: -1890px -1700px;
	}
	60% {
		background-position: 0 -1800px;
	}
	65% {
		background-position: -100px -1800px;
	}
	70% {
		background-position: -200px -1800px;
	}
	75% {
		background-position: -300px -1800px;
	}
	80% {
		background-position: -400px -1800px;
	}
	85% {
		background-position: -500px -1800px;
	}
	90% {
		background-position: -600px -1800px;
	}
	95% {
		background-position: -800px -1800px;
	}
}
@keyframes outgoingSupport {
	from {
		background-position: 0 -1600px;
	}
	5% {
		background-position: -700px -1800px;
	}
	10% {
		background-position: -900px -1800px;
	}
	15% {
		background-position: -1000px -1800px;
	}
	20% {
		background-position: -1100px -1800px;
	}
	25% {
		background-position: -1200px -1800px;
	}
	30% {
		background-position: -1300px -1800px;
	}
	35% {
		background-position: -1400px -1800px;
	}
	40% {
		background-position: -1500px -1800px;
	}
	45% {
		background-position: -1890px -1500px;
	}
	50% {
		background-position: -1890px -1600px;
	}
	55% {
		background-position: -1890px -1700px;
	}
	60% {
		background-position: 0 -1800px;
	}
	65% {
		background-position: -100px -1800px;
	}
	70% {
		background-position: -200px -1800px;
	}
	75% {
		background-position: -300px -1800px;
	}
	80% {
		background-position: -400px -1800px;
	}
	85% {
		background-position: -500px -1800px;
	}
	90% {
		background-position: -600px -1800px;
	}
	95% {
		background-position: -800px -1800px;
	}
}
@-webkit-keyframes outgoingSupportAndAttack {
	from {
		background-position: -1600px -1800px;
	}
	5% {
		background-position: -1990px -800px;
	}
	10% {
		background-position: -1990px -1000px;
	}
	15% {
		background-position: -1990px -1100px;
	}
	20% {
		background-position: -1990px -1200px;
	}
	25% {
		background-position: -1990px -1300px;
	}
	30% {
		background-position: -1990px -1400px;
	}
	35% {
		background-position: -1990px -1500px;
	}
	40% {
		background-position: -1990px -1600px;
	}
	45% {
		background-position: -1700px -1800px;
	}
	50% {
		background-position: -1800px -1800px;
	}
	55% {
		background-position: -1990px 0;
	}
	60% {
		background-position: -1990px -100px;
	}
	65% {
		background-position: -1990px -200px;
	}
	70% {
		background-position: -1990px -300px;
	}
	75% {
		background-position: -1990px -400px;
	}
	80% {
		background-position: -1990px -500px;
	}
	85% {
		background-position: -1990px -600px;
	}
	90% {
		background-position: -1990px -700px;
	}
	95% {
		background-position: -1990px -900px;
	}
}
@-moz-keyframes outgoingSupportAndAttack {
	from {
		background-position: -1600px -1800px;
	}
	5% {
		background-position: -1990px -800px;
	}
	10% {
		background-position: -1990px -1000px;
	}
	15% {
		background-position: -1990px -1100px;
	}
	20% {
		background-position: -1990px -1200px;
	}
	25% {
		background-position: -1990px -1300px;
	}
	30% {
		background-position: -1990px -1400px;
	}
	35% {
		background-position: -1990px -1500px;
	}
	40% {
		background-position: -1990px -1600px;
	}
	45% {
		background-position: -1700px -1800px;
	}
	50% {
		background-position: -1800px -1800px;
	}
	55% {
		background-position: -1990px 0;
	}
	60% {
		background-position: -1990px -100px;
	}
	65% {
		background-position: -1990px -200px;
	}
	70% {
		background-position: -1990px -300px;
	}
	75% {
		background-position: -1990px -400px;
	}
	80% {
		background-position: -1990px -500px;
	}
	85% {
		background-position: -1990px -600px;
	}
	90% {
		background-position: -1990px -700px;
	}
	95% {
		background-position: -1990px -900px;
	}
}
@-ms-keyframes outgoingSupportAndAttack {
	from {
		background-position: -1600px -1800px;
	}
	5% {
		background-position: -1990px -800px;
	}
	10% {
		background-position: -1990px -1000px;
	}
	15% {
		background-position: -1990px -1100px;
	}
	20% {
		background-position: -1990px -1200px;
	}
	25% {
		background-position: -1990px -1300px;
	}
	30% {
		background-position: -1990px -1400px;
	}
	35% {
		background-position: -1990px -1500px;
	}
	40% {
		background-position: -1990px -1600px;
	}
	45% {
		background-position: -1700px -1800px;
	}
	50% {
		background-position: -1800px -1800px;
	}
	55% {
		background-position: -1990px 0;
	}
	60% {
		background-position: -1990px -100px;
	}
	65% {
		background-position: -1990px -200px;
	}
	70% {
		background-position: -1990px -300px;
	}
	75% {
		background-position: -1990px -400px;
	}
	80% {
		background-position: -1990px -500px;
	}
	85% {
		background-position: -1990px -600px;
	}
	90% {
		background-position: -1990px -700px;
	}
	95% {
		background-position: -1990px -900px;
	}
}
@-o-keyframes outgoingSupportAndAttack {
	from {
		background-position: -1600px -1800px;
	}
	5% {
		background-position: -1990px -800px;
	}
	10% {
		background-position: -1990px -1000px;
	}
	15% {
		background-position: -1990px -1100px;
	}
	20% {
		background-position: -1990px -1200px;
	}
	25% {
		background-position: -1990px -1300px;
	}
	30% {
		background-position: -1990px -1400px;
	}
	35% {
		background-position: -1990px -1500px;
	}
	40% {
		background-position: -1990px -1600px;
	}
	45% {
		background-position: -1700px -1800px;
	}
	50% {
		background-position: -1800px -1800px;
	}
	55% {
		background-position: -1990px 0;
	}
	60% {
		background-position: -1990px -100px;
	}
	65% {
		background-position: -1990px -200px;
	}
	70% {
		background-position: -1990px -300px;
	}
	75% {
		background-position: -1990px -400px;
	}
	80% {
		background-position: -1990px -500px;
	}
	85% {
		background-position: -1990px -600px;
	}
	90% {
		background-position: -1990px -700px;
	}
	95% {
		background-position: -1990px -900px;
	}
}
@keyframes outgoingSupportAndAttack {
	from {
		background-position: -1600px -1800px;
	}
	5% {
		background-position: -1990px -800px;
	}
	10% {
		background-position: -1990px -1000px;
	}
	15% {
		background-position: -1990px -1100px;
	}
	20% {
		background-position: -1990px -1200px;
	}
	25% {
		background-position: -1990px -1300px;
	}
	30% {
		background-position: -1990px -1400px;
	}
	35% {
		background-position: -1990px -1500px;
	}
	40% {
		background-position: -1990px -1600px;
	}
	45% {
		background-position: -1700px -1800px;
	}
	50% {
		background-position: -1800px -1800px;
	}
	55% {
		background-position: -1990px 0;
	}
	60% {
		background-position: -1990px -100px;
	}
	65% {
		background-position: -1990px -200px;
	}
	70% {
		background-position: -1990px -300px;
	}
	75% {
		background-position: -1990px -400px;
	}
	80% {
		background-position: -1990px -500px;
	}
	85% {
		background-position: -1990px -600px;
	}
	90% {
		background-position: -1990px -700px;
	}
	95% {
		background-position: -1990px -900px;
	}
}
@-webkit-keyframes incomingAttack {
	from {
		background-position: -600px -1900px;
	}
	5% {
		background-position: -1890px -1400px;
	}
	10% {
		background-position: -300px -1600px;
	}
	15% {
		background-position: -400px -1600px;
	}
	20% {
		background-position: -500px -1600px;
	}
	25% {
		background-position: -600px -1600px;
	}
	30% {
		background-position: -700px -1600px;
	}
	35% {
		background-position: -800px -1600px;
	}
	40% {
		background-position: -900px -1600px;
	}
	45% {
		background-position: -500px -1900px;
	}
	50% {
		background-position: -400px -1900px;
	}
	55% {
		background-position: -300px -1900px;
	}
	60% {
		background-position: -200px -1900px;
	}
	65% {
		background-position: -100px -1900px;
	}
	70% {
		background-position: 0 -1900px;
	}
	75% {
		background-position: -1990px -1800px;
	}
	80% {
		background-position: -1990px -1700px;
	}
	85% {
		background-position: -200px -1600px;
	}
	90% {
		background-position: -100px -1600px;
	}
	95% {
		background-position: -700px -1900px;
	}
}
@-moz-keyframes incomingAttack {
	from {
		background-position: -600px -1900px;
	}
	5% {
		background-position: -1890px -1400px;
	}
	10% {
		background-position: -300px -1600px;
	}
	15% {
		background-position: -400px -1600px;
	}
	20% {
		background-position: -500px -1600px;
	}
	25% {
		background-position: -600px -1600px;
	}
	30% {
		background-position: -700px -1600px;
	}
	35% {
		background-position: -800px -1600px;
	}
	40% {
		background-position: -900px -1600px;
	}
	45% {
		background-position: -500px -1900px;
	}
	50% {
		background-position: -400px -1900px;
	}
	55% {
		background-position: -300px -1900px;
	}
	60% {
		background-position: -200px -1900px;
	}
	65% {
		background-position: -100px -1900px;
	}
	70% {
		background-position: 0 -1900px;
	}
	75% {
		background-position: -1990px -1800px;
	}
	80% {
		background-position: -1990px -1700px;
	}
	85% {
		background-position: -200px -1600px;
	}
	90% {
		background-position: -100px -1600px;
	}
	95% {
		background-position: -700px -1900px;
	}
}
@-ms-keyframes incomingAttack {
	from {
		background-position: -600px -1900px;
	}
	5% {
		background-position: -1890px -1400px;
	}
	10% {
		background-position: -300px -1600px;
	}
	15% {
		background-position: -400px -1600px;
	}
	20% {
		background-position: -500px -1600px;
	}
	25% {
		background-position: -600px -1600px;
	}
	30% {
		background-position: -700px -1600px;
	}
	35% {
		background-position: -800px -1600px;
	}
	40% {
		background-position: -900px -1600px;
	}
	45% {
		background-position: -500px -1900px;
	}
	50% {
		background-position: -400px -1900px;
	}
	55% {
		background-position: -300px -1900px;
	}
	60% {
		background-position: -200px -1900px;
	}
	65% {
		background-position: -100px -1900px;
	}
	70% {
		background-position: 0 -1900px;
	}
	75% {
		background-position: -1990px -1800px;
	}
	80% {
		background-position: -1990px -1700px;
	}
	85% {
		background-position: -200px -1600px;
	}
	90% {
		background-position: -100px -1600px;
	}
	95% {
		background-position: -700px -1900px;
	}
}
@-o-keyframes incomingAttack {
	from {
		background-position: -600px -1900px;
	}
	5% {
		background-position: -1890px -1400px;
	}
	10% {
		background-position: -300px -1600px;
	}
	15% {
		background-position: -400px -1600px;
	}
	20% {
		background-position: -500px -1600px;
	}
	25% {
		background-position: -600px -1600px;
	}
	30% {
		background-position: -700px -1600px;
	}
	35% {
		background-position: -800px -1600px;
	}
	40% {
		background-position: -900px -1600px;
	}
	45% {
		background-position: -500px -1900px;
	}
	50% {
		background-position: -400px -1900px;
	}
	55% {
		background-position: -300px -1900px;
	}
	60% {
		background-position: -200px -1900px;
	}
	65% {
		background-position: -100px -1900px;
	}
	70% {
		background-position: 0 -1900px;
	}
	75% {
		background-position: -1990px -1800px;
	}
	80% {
		background-position: -1990px -1700px;
	}
	85% {
		background-position: -200px -1600px;
	}
	90% {
		background-position: -100px -1600px;
	}
	95% {
		background-position: -700px -1900px;
	}
}
@keyframes incomingAttack {
	from {
		background-position: -600px -1900px;
	}
	5% {
		background-position: -1890px -1400px;
	}
	10% {
		background-position: -300px -1600px;
	}
	15% {
		background-position: -400px -1600px;
	}
	20% {
		background-position: -500px -1600px;
	}
	25% {
		background-position: -600px -1600px;
	}
	30% {
		background-position: -700px -1600px;
	}
	35% {
		background-position: -800px -1600px;
	}
	40% {
		background-position: -900px -1600px;
	}
	45% {
		background-position: -500px -1900px;
	}
	50% {
		background-position: -400px -1900px;
	}
	55% {
		background-position: -300px -1900px;
	}
	60% {
		background-position: -200px -1900px;
	}
	65% {
		background-position: -100px -1900px;
	}
	70% {
		background-position: 0 -1900px;
	}
	75% {
		background-position: -1990px -1800px;
	}
	80% {
		background-position: -1990px -1700px;
	}
	85% {
		background-position: -200px -1600px;
	}
	90% {
		background-position: -100px -1600px;
	}
	95% {
		background-position: -700px -1900px;
	}
}
@-webkit-keyframes incomingRobberAttack {
	from {
		background-position: -1000px -1600px;
	}
	5% {
		background-position: -300px -1700px;
	}
	10% {
		background-position: -500px -1700px;
	}
	15% {
		background-position: -600px -1700px;
	}
	20% {
		background-position: -700px -1700px;
	}
	25% {
		background-position: -800px -1700px;
	}
	30% {
		background-position: -900px -1700px;
	}
	35% {
		background-position: -1000px -1700px;
	}
	40% {
		background-position: -1100px -1700px;
	}
	45% {
		background-position: -1100px -1600px;
	}
	50% {
		background-position: -1200px -1600px;
	}
	55% {
		background-position: -1300px -1600px;
	}
	60% {
		background-position: -1400px -1600px;
	}
	65% {
		background-position: -1500px -1600px;
	}
	70% {
		background-position: -1600px -1600px;
	}
	75% {
		background-position: -1700px -1600px;
	}
	80% {
		background-position: 0 -1700px;
	}
	85% {
		background-position: -100px -1700px;
	}
	90% {
		background-position: -200px -1700px;
	}
	95% {
		background-position: -400px -1700px;
	}
}
@-moz-keyframes incomingRobberAttack {
	from {
		background-position: -1000px -1600px;
	}
	5% {
		background-position: -300px -1700px;
	}
	10% {
		background-position: -500px -1700px;
	}
	15% {
		background-position: -600px -1700px;
	}
	20% {
		background-position: -700px -1700px;
	}
	25% {
		background-position: -800px -1700px;
	}
	30% {
		background-position: -900px -1700px;
	}
	35% {
		background-position: -1000px -1700px;
	}
	40% {
		background-position: -1100px -1700px;
	}
	45% {
		background-position: -1100px -1600px;
	}
	50% {
		background-position: -1200px -1600px;
	}
	55% {
		background-position: -1300px -1600px;
	}
	60% {
		background-position: -1400px -1600px;
	}
	65% {
		background-position: -1500px -1600px;
	}
	70% {
		background-position: -1600px -1600px;
	}
	75% {
		background-position: -1700px -1600px;
	}
	80% {
		background-position: 0 -1700px;
	}
	85% {
		background-position: -100px -1700px;
	}
	90% {
		background-position: -200px -1700px;
	}
	95% {
		background-position: -400px -1700px;
	}
}
@-ms-keyframes incomingRobberAttack {
	from {
		background-position: -1000px -1600px;
	}
	5% {
		background-position: -300px -1700px;
	}
	10% {
		background-position: -500px -1700px;
	}
	15% {
		background-position: -600px -1700px;
	}
	20% {
		background-position: -700px -1700px;
	}
	25% {
		background-position: -800px -1700px;
	}
	30% {
		background-position: -900px -1700px;
	}
	35% {
		background-position: -1000px -1700px;
	}
	40% {
		background-position: -1100px -1700px;
	}
	45% {
		background-position: -1100px -1600px;
	}
	50% {
		background-position: -1200px -1600px;
	}
	55% {
		background-position: -1300px -1600px;
	}
	60% {
		background-position: -1400px -1600px;
	}
	65% {
		background-position: -1500px -1600px;
	}
	70% {
		background-position: -1600px -1600px;
	}
	75% {
		background-position: -1700px -1600px;
	}
	80% {
		background-position: 0 -1700px;
	}
	85% {
		background-position: -100px -1700px;
	}
	90% {
		background-position: -200px -1700px;
	}
	95% {
		background-position: -400px -1700px;
	}
}
@-o-keyframes incomingRobberAttack {
	from {
		background-position: -1000px -1600px;
	}
	5% {
		background-position: -300px -1700px;
	}
	10% {
		background-position: -500px -1700px;
	}
	15% {
		background-position: -600px -1700px;
	}
	20% {
		background-position: -700px -1700px;
	}
	25% {
		background-position: -800px -1700px;
	}
	30% {
		background-position: -900px -1700px;
	}
	35% {
		background-position: -1000px -1700px;
	}
	40% {
		background-position: -1100px -1700px;
	}
	45% {
		background-position: -1100px -1600px;
	}
	50% {
		background-position: -1200px -1600px;
	}
	55% {
		background-position: -1300px -1600px;
	}
	60% {
		background-position: -1400px -1600px;
	}
	65% {
		background-position: -1500px -1600px;
	}
	70% {
		background-position: -1600px -1600px;
	}
	75% {
		background-position: -1700px -1600px;
	}
	80% {
		background-position: 0 -1700px;
	}
	85% {
		background-position: -100px -1700px;
	}
	90% {
		background-position: -200px -1700px;
	}
	95% {
		background-position: -400px -1700px;
	}
}
@keyframes incomingRobberAttack {
	from {
		background-position: -1000px -1600px;
	}
	5% {
		background-position: -300px -1700px;
	}
	10% {
		background-position: -500px -1700px;
	}
	15% {
		background-position: -600px -1700px;
	}
	20% {
		background-position: -700px -1700px;
	}
	25% {
		background-position: -800px -1700px;
	}
	30% {
		background-position: -900px -1700px;
	}
	35% {
		background-position: -1000px -1700px;
	}
	40% {
		background-position: -1100px -1700px;
	}
	45% {
		background-position: -1100px -1600px;
	}
	50% {
		background-position: -1200px -1600px;
	}
	55% {
		background-position: -1300px -1600px;
	}
	60% {
		background-position: -1400px -1600px;
	}
	65% {
		background-position: -1500px -1600px;
	}
	70% {
		background-position: -1600px -1600px;
	}
	75% {
		background-position: -1700px -1600px;
	}
	80% {
		background-position: 0 -1700px;
	}
	85% {
		background-position: -100px -1700px;
	}
	90% {
		background-position: -200px -1700px;
	}
	95% {
		background-position: -400px -1700px;
	}
}
@-webkit-keyframes mapFireworks {
	from {
		background-position: -252px -1520px;
	}
	55.35714% {
		background-position: -756px -1440px;
	}
	57.14286% {
		background-position: -126px -1440px;
	}
	58.92857% {
		background-position: 0 -1440px;
	}
	60.71429% {
		background-position: -1764px -1356px;
	}
	62.5% {
		background-position: -1638px -1356px;
	}
	64.28571% {
		background-position: -1386px -1356px;
	}
	66.07143% {
		background-position: -378px -1520px;
	}
	67.85714% {
		background-position: -1008px -1356px;
	}
	69.64286% {
		background-position: -126px -1520px;
	}
	71.42857% {
		background-position: 0 -1520px;
	}
	73.21429% {
		background-position: -1764px -1440px;
	}
	75% {
		background-position: -1638px -1440px;
	}
	76.78571% {
		background-position: -1512px -1440px;
	}
	78.57143% {
		background-position: -1386px -1440px;
	}
	80.35714% {
		background-position: -1260px -1440px;
	}
	82.14286% {
		background-position: -1134px -1440px;
	}
	83.92857% {
		background-position: -1512px -1356px;
	}
	85.71429% {
		background-position: -882px -1440px;
	}
	87.5% {
		background-position: -630px -1440px;
	}
	89.28571% {
		background-position: -504px -1440px;
	}
	91.07143% {
		background-position: -378px -1440px;
	}
	92.85714% {
		background-position: -1260px -1356px;
	}
	94.64286% {
		background-position: -1134px -1356px;
	}
	96.42857% {
		background-position: -1008px -1440px;
	}
	98.21429% {
		background-position: -252px -1440px;
	}
}
@-moz-keyframes mapFireworks {
	from {
		background-position: -252px -1520px;
	}
	55.35714% {
		background-position: -756px -1440px;
	}
	57.14286% {
		background-position: -126px -1440px;
	}
	58.92857% {
		background-position: 0 -1440px;
	}
	60.71429% {
		background-position: -1764px -1356px;
	}
	62.5% {
		background-position: -1638px -1356px;
	}
	64.28571% {
		background-position: -1386px -1356px;
	}
	66.07143% {
		background-position: -378px -1520px;
	}
	67.85714% {
		background-position: -1008px -1356px;
	}
	69.64286% {
		background-position: -126px -1520px;
	}
	71.42857% {
		background-position: 0 -1520px;
	}
	73.21429% {
		background-position: -1764px -1440px;
	}
	75% {
		background-position: -1638px -1440px;
	}
	76.78571% {
		background-position: -1512px -1440px;
	}
	78.57143% {
		background-position: -1386px -1440px;
	}
	80.35714% {
		background-position: -1260px -1440px;
	}
	82.14286% {
		background-position: -1134px -1440px;
	}
	83.92857% {
		background-position: -1512px -1356px;
	}
	85.71429% {
		background-position: -882px -1440px;
	}
	87.5% {
		background-position: -630px -1440px;
	}
	89.28571% {
		background-position: -504px -1440px;
	}
	91.07143% {
		background-position: -378px -1440px;
	}
	92.85714% {
		background-position: -1260px -1356px;
	}
	94.64286% {
		background-position: -1134px -1356px;
	}
	96.42857% {
		background-position: -1008px -1440px;
	}
	98.21429% {
		background-position: -252px -1440px;
	}
}
@-ms-keyframes mapFireworks {
	from {
		background-position: -252px -1520px;
	}
	55.35714% {
		background-position: -756px -1440px;
	}
	57.14286% {
		background-position: -126px -1440px;
	}
	58.92857% {
		background-position: 0 -1440px;
	}
	60.71429% {
		background-position: -1764px -1356px;
	}
	62.5% {
		background-position: -1638px -1356px;
	}
	64.28571% {
		background-position: -1386px -1356px;
	}
	66.07143% {
		background-position: -378px -1520px;
	}
	67.85714% {
		background-position: -1008px -1356px;
	}
	69.64286% {
		background-position: -126px -1520px;
	}
	71.42857% {
		background-position: 0 -1520px;
	}
	73.21429% {
		background-position: -1764px -1440px;
	}
	75% {
		background-position: -1638px -1440px;
	}
	76.78571% {
		background-position: -1512px -1440px;
	}
	78.57143% {
		background-position: -1386px -1440px;
	}
	80.35714% {
		background-position: -1260px -1440px;
	}
	82.14286% {
		background-position: -1134px -1440px;
	}
	83.92857% {
		background-position: -1512px -1356px;
	}
	85.71429% {
		background-position: -882px -1440px;
	}
	87.5% {
		background-position: -630px -1440px;
	}
	89.28571% {
		background-position: -504px -1440px;
	}
	91.07143% {
		background-position: -378px -1440px;
	}
	92.85714% {
		background-position: -1260px -1356px;
	}
	94.64286% {
		background-position: -1134px -1356px;
	}
	96.42857% {
		background-position: -1008px -1440px;
	}
	98.21429% {
		background-position: -252px -1440px;
	}
}
@-o-keyframes mapFireworks {
	from {
		background-position: -252px -1520px;
	}
	55.35714% {
		background-position: -756px -1440px;
	}
	57.14286% {
		background-position: -126px -1440px;
	}
	58.92857% {
		background-position: 0 -1440px;
	}
	60.71429% {
		background-position: -1764px -1356px;
	}
	62.5% {
		background-position: -1638px -1356px;
	}
	64.28571% {
		background-position: -1386px -1356px;
	}
	66.07143% {
		background-position: -378px -1520px;
	}
	67.85714% {
		background-position: -1008px -1356px;
	}
	69.64286% {
		background-position: -126px -1520px;
	}
	71.42857% {
		background-position: 0 -1520px;
	}
	73.21429% {
		background-position: -1764px -1440px;
	}
	75% {
		background-position: -1638px -1440px;
	}
	76.78571% {
		background-position: -1512px -1440px;
	}
	78.57143% {
		background-position: -1386px -1440px;
	}
	80.35714% {
		background-position: -1260px -1440px;
	}
	82.14286% {
		background-position: -1134px -1440px;
	}
	83.92857% {
		background-position: -1512px -1356px;
	}
	85.71429% {
		background-position: -882px -1440px;
	}
	87.5% {
		background-position: -630px -1440px;
	}
	89.28571% {
		background-position: -504px -1440px;
	}
	91.07143% {
		background-position: -378px -1440px;
	}
	92.85714% {
		background-position: -1260px -1356px;
	}
	94.64286% {
		background-position: -1134px -1356px;
	}
	96.42857% {
		background-position: -1008px -1440px;
	}
	98.21429% {
		background-position: -252px -1440px;
	}
}
@keyframes mapFireworks {
	from {
		background-position: -252px -1520px;
	}
	55.35714% {
		background-position: -756px -1440px;
	}
	57.14286% {
		background-position: -126px -1440px;
	}
	58.92857% {
		background-position: 0 -1440px;
	}
	60.71429% {
		background-position: -1764px -1356px;
	}
	62.5% {
		background-position: -1638px -1356px;
	}
	64.28571% {
		background-position: -1386px -1356px;
	}
	66.07143% {
		background-position: -378px -1520px;
	}
	67.85714% {
		background-position: -1008px -1356px;
	}
	69.64286% {
		background-position: -126px -1520px;
	}
	71.42857% {
		background-position: 0 -1520px;
	}
	73.21429% {
		background-position: -1764px -1440px;
	}
	75% {
		background-position: -1638px -1440px;
	}
	76.78571% {
		background-position: -1512px -1440px;
	}
	78.57143% {
		background-position: -1386px -1440px;
	}
	80.35714% {
		background-position: -1260px -1440px;
	}
	82.14286% {
		background-position: -1134px -1440px;
	}
	83.92857% {
		background-position: -1512px -1356px;
	}
	85.71429% {
		background-position: -882px -1440px;
	}
	87.5% {
		background-position: -630px -1440px;
	}
	89.28571% {
		background-position: -504px -1440px;
	}
	91.07143% {
		background-position: -378px -1440px;
	}
	92.85714% {
		background-position: -1260px -1356px;
	}
	94.64286% {
		background-position: -1134px -1356px;
	}
	96.42857% {
		background-position: -1008px -1440px;
	}
	98.21429% {
		background-position: -252px -1440px;
	}
}
.cnt {
	line-height: 0;
}
.bl {
	width: 20px;
	height: 20px;
	margin: 0px;
	&:hover {
		opacity: 0.2;
	}
	&:hover.moveto {
		background: #fff;
		width: 16px;
		height: 16px;
		border: 2px dotted #000;
	}
}
.bl.empty {
	background: aqua;
}
.bl.user {
	background: blue;
}
.bl.barbarian {
	background: gray;
}
.bl.selected {
	background: #fff;
}
#map {
	.zoomBar {
		position: absolute;
		left: 0;
		top: 330px;
		z-index: 10;
		.mainLayoutMenuButton {
			z-index: 2;
			height: 25px;
			width: 30px;
			&:after {
				width: 10px;
				height: 9px;
				top: 6px;
				right: -6px;
			}
			>i {
				top: 4px;
			}
		}
		.mainLayoutMenuButton.zoomOut {
			margin-top: 4px;
		}
		.zoomLevel {
			position: absolute;
			z-index: 1;
			height: 25px;
			width: 51px;
			top: 14px;
			border-top: 1px solid #7b746e;
			border-bottom: 1px solid #7b746e;
			background-color: $background-color_1;
			&:after {
				content: '';
				position: absolute;
				top: 6px;
				right: -7px;
				width: 11px;
				height: 11px;
				background-image: -owg-linear-gradient(45deg,rgba(241,240,238,0.7) 50%,transparent 50%);
				background-image: -webkit-linear-gradient(45deg,rgba(241,240,238,0.7) 50%,transparent 50%);
				background-image: -moz-linear-gradient(45deg,rgba(241,240,238,0.7) 50%,transparent 50%);
				background-image: -o-linear-gradient(45deg,rgba(241,240,238,0.7) 50%,transparent 50%);
				background-image: linear-gradient(45deg,rgba(241,240,238,0.7) 50%,transparent 50%);
				border-bottom: 1px solid #7b746e;
				border-left: 1px solid #7b746e;
				-webkit-transform: rotate(225deg) skew(30deg,30deg);
				-moz-transform: rotate(225deg) skew(30deg,30deg);
				-ms-transform: rotate(225deg) skew(30deg,30deg);
				-o-transform: rotate(225deg) skew(30deg,30deg);
				transform: rotate(225deg) skew(30deg,30deg);
				border-width: 2px;
			}
			>i {
				top: 5px;
				left: 33px;
			}
		}
		.filterButton {
			height: 30px;
			margin-top: 10px;
			.buttonWrapper {
				line-height: 30px;
			}
		}
		.goToButton {
			height: 30px;
			margin-top: 4px;
			.buttonWrapper {
				line-height: 30px;
			}
		}
		.goHomeButton {
			margin-top: 4px;
			height: 30px;
			>i {
				top: 6px;
			}
		}
		.filters {
			position: absolute;
			top: 0;
			left: 29px;
			border: 1px solid #fff;
			-webkit-box-shadow: 1px 0 1px rgba(0,0,0,0.7);
			-moz-box-shadow: 1px 0 1px rgba(0,0,0,0.7);
			box-shadow: 1px 0 1px rgba(0,0,0,0.7);
			background-color: $background-color_2;
			padding: 5px;
			text-align: left;
			.content {
				width: 150px;
				font-size: .76923rem;
				padding: 5px;
				background-color: $background-color_3;
				border: 1px solid #b8b2a9;
				.serverautocompleteContainer {
					display: inline-block;
					width: 127px;
					input {
						width: 125px;
					}
					label {
						top: 22px;
					}
				}
				.serverautocompleteContainer+i.centerResult {
					top: 2px;
					margin-left: 1px;
				}
				.header {
					width: 100%;
					border-bottom: 1px solid #b8b2a9;
					margin-bottom: 5px;
					padding-bottom: 3px;
					font-weight: bold;
					i {
						position: relative;
						top: auto;
						display: inline-block;
						padding-left: 7px;
						padding-right: 1px;
						float: right;
						border-left: 1px solid #b8b2a9;
					}
				}
				.footer {
					border-top: 1px solid #b8b2a9;
					margin-top: 8px;
					padding: 4px 0;
					.arrowButtonContainer {
						float: right;
						.arrowButton {
							display: inline-block;
							padding: 0 3px;
							i {
								vertical-align: middle;
							}
						}
					}
				}
				.option {
					margin: 1px;
					padding-right: 30px;
					padding-bottom: 3px;
					white-space: nowrap;
					border-top: 1px solid #b8b2a9;
					i {
						top: 5px;
					}
					span {
						margin-top: 3px;
						display: inline-block;
					}
				}
			}
		}
	}
	#overlayMarkers {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;
		.villageName {
			position: absolute;
			z-index: 4;
			width: 250px;
			font-size: .84615rem;
			text-align: center;
			margin: 14px -125px 0 -125px;
			.content {
				position: relative;
				display: inline-block;
				.inner {
					display: inline-block;
					line-height: 18px;
					height: 20px;
					padding: 0 5px;
					box-sizing: border-box;
					background-color: $background-color_4;
					border-top: 1px solid #b8b2a9;
					border-bottom: 1px solid #b8b2a9;
					-webkit-box-shadow: inset 0 2px 0 -1px #fff,inset 0 -2px 0 -1px #fff;
					-moz-box-shadow: inset 0 2px 0 -1px #fff,inset 0 -2px 0 -1px #fff;
					box-shadow: inset 0 2px 0 -1px #fff,inset 0 -2px 0 -1px #fff;
					min-width: 90px;
				}
				&:before {
					content: "";
					position: absolute;
					top: 0;
					box-sizing: border-box;
					width: 9px;
					height: 19px;
					border-top: 1px solid #b8b2a9;
					left: -5px;
					border-left: 1px solid #b8b2a9;
					background-image: linear-gradient(to bottom right,rgba(235,235,235,0.85),rgba(235,235,235,0.85) 50%,transparent 50%,transparent);
					-webkit-transform: skewX(23deg);
					-moz-transform: skewX(23deg);
					-ms-transform: skewX(23deg);
					-o-transform: skewX(23deg);
					transform: skewX(23deg);
					-webkit-box-shadow: inset 0 2px 0 -1px #fff,inset 2px 0 0 -1px #fff;
					-moz-box-shadow: inset 0 2px 0 -1px #fff,inset 2px 0 0 -1px #fff;
					box-shadow: inset 0 2px 0 -1px #fff,inset 2px 0 0 -1px #fff;
				}
				&:after {
					content: "";
					position: absolute;
					top: 0;
					box-sizing: border-box;
					width: 9px;
					height: 19px;
					border-top: 1px solid #b8b2a9;
					right: -5px;
					border-right: 1px solid #b8b2a9;
					background-image: linear-gradient(to bottom left,rgba(235,235,235,0.85),rgba(235,235,235,0.85) 50%,transparent 50%,transparent);
					-webkit-transform: skewX(-23deg);
					-moz-transform: skewX(-23deg);
					-ms-transform: skewX(-23deg);
					-o-transform: skewX(-23deg);
					transform: skewX(-23deg);
					-webkit-box-shadow: inset 0 2px 0 -1px #fff,inset -2px 0 0 -1px #fff;
					-moz-box-shadow: inset 0 2px 0 -1px #fff,inset -2px 0 0 -1px #fff;
					box-shadow: inset 0 2px 0 -1px #fff,inset -2px 0 0 -1px #fff;
				}
			}
		}
		.villageTreasuries {
			position: absolute;
			z-index: 4;
			width: 250px;
			font-size: .84615rem;
			text-align: center;
			margin: 14px -125px 0 -125px;
			.content {
				position: relative;
				display: inline-block;
				.inner {
					display: inline-block;
					line-height: 18px;
					height: 20px;
					padding: 0 5px;
					box-sizing: border-box;
					background-color: $background-color_4;
					border-top: 1px solid #b8b2a9;
					border-bottom: 1px solid #b8b2a9;
					-webkit-box-shadow: inset 0 2px 0 -1px #fff,inset 0 -2px 0 -1px #fff;
					-moz-box-shadow: inset 0 2px 0 -1px #fff,inset 0 -2px 0 -1px #fff;
					box-shadow: inset 0 2px 0 -1px #fff,inset 0 -2px 0 -1px #fff;
					min-width: 90px;
					background-color: $background-color_6;
					min-width: 55px;
					i {
						margin-right: 5px;
						margin-top: 1px;
						vertical-align: top;
					}
				}
				&:before {
					content: "";
					position: absolute;
					top: 0;
					box-sizing: border-box;
					width: 9px;
					height: 19px;
					border-top: 1px solid #b8b2a9;
					left: -5px;
					border-left: 1px solid #b8b2a9;
					background-image: linear-gradient(to bottom right,rgba(235,235,235,0.85),rgba(235,235,235,0.85) 50%,transparent 50%,transparent);
					-webkit-transform: skewX(23deg);
					-moz-transform: skewX(23deg);
					-ms-transform: skewX(23deg);
					-o-transform: skewX(23deg);
					transform: skewX(23deg);
					-webkit-box-shadow: inset 0 2px 0 -1px #fff,inset 2px 0 0 -1px #fff;
					-moz-box-shadow: inset 0 2px 0 -1px #fff,inset 2px 0 0 -1px #fff;
					box-shadow: inset 0 2px 0 -1px #fff,inset 2px 0 0 -1px #fff;
					left: -5px;
					border-left: 1px solid #fdf15f;
					background-image: linear-gradient(to bottom right,rgba(253,241,95,0.85),rgba(253,241,95,0.85) 50%,transparent 50%,transparent);
					-webkit-transform: skewX(23deg);
					-moz-transform: skewX(23deg);
					-ms-transform: skewX(23deg);
					-o-transform: skewX(23deg);
					transform: skewX(23deg);
				}
				&:after {
					content: "";
					position: absolute;
					top: 0;
					box-sizing: border-box;
					width: 9px;
					height: 19px;
					border-top: 1px solid #b8b2a9;
					right: -5px;
					border-right: 1px solid #b8b2a9;
					background-image: linear-gradient(to bottom left,rgba(235,235,235,0.85),rgba(235,235,235,0.85) 50%,transparent 50%,transparent);
					-webkit-transform: skewX(-23deg);
					-moz-transform: skewX(-23deg);
					-ms-transform: skewX(-23deg);
					-o-transform: skewX(-23deg);
					transform: skewX(-23deg);
					-webkit-box-shadow: inset 0 2px 0 -1px #fff,inset -2px 0 0 -1px #fff;
					-moz-box-shadow: inset 0 2px 0 -1px #fff,inset -2px 0 0 -1px #fff;
					box-shadow: inset 0 2px 0 -1px #fff,inset -2px 0 0 -1px #fff;
					right: -5px;
					border-right: 1px solid #fdf15f;
					background-image: linear-gradient(to bottom left,rgba(253,241,95,0.85),rgba(253,241,95,0.85) 50%,transparent 50%,transparent);
					-webkit-transform: skewX(-23deg);
					-moz-transform: skewX(-23deg);
					-ms-transform: skewX(-23deg);
					-o-transform: skewX(-23deg);
					transform: skewX(-23deg);
				}
			}
		}
		.villageName.robber {
			.content {
				.inner {
					color: $color_1;
					background-color: $background-color_5;
				}
				&:before {
					left: -5px;
					border-left: 1px solid #b8b2a9;
					background-image: linear-gradient(to bottom right,rgba(70,63,57,0.85),rgba(70,63,57,0.85) 50%,transparent 50%,transparent);
					-webkit-transform: skewX(23deg);
					-moz-transform: skewX(23deg);
					-ms-transform: skewX(23deg);
					-o-transform: skewX(23deg);
					transform: skewX(23deg);
					-webkit-box-shadow: inset 0 2px 0 -1px #fff,inset 2px 0 0 -1px #fff;
					-moz-box-shadow: inset 0 2px 0 -1px #fff,inset 2px 0 0 -1px #fff;
					box-shadow: inset 0 2px 0 -1px #fff,inset 2px 0 0 -1px #fff;
				}
				&:after {
					right: -5px;
					border-right: 1px solid #b8b2a9;
					background-image: linear-gradient(to bottom left,rgba(70,63,57,0.85),rgba(70,63,57,0.85) 50%,transparent 50%,transparent);
					-webkit-transform: skewX(-23deg);
					-moz-transform: skewX(-23deg);
					-ms-transform: skewX(-23deg);
					-o-transform: skewX(-23deg);
					transform: skewX(-23deg);
					-webkit-box-shadow: inset 0 2px 0 -1px #fff,inset -2px 0 0 -1px #fff;
					-moz-box-shadow: inset 0 2px 0 -1px #fff,inset -2px 0 0 -1px #fff;
					box-shadow: inset 0 2px 0 -1px #fff,inset -2px 0 0 -1px #fff;
				}
			}
		}
		.villageTreasuries.robber {
			.content {
				.inner {
					color: $color_1;
					background-color: $background-color_5;
				}
				&:before {
					left: -5px;
					border-left: 1px solid #b8b2a9;
					background-image: linear-gradient(to bottom right,rgba(70,63,57,0.85),rgba(70,63,57,0.85) 50%,transparent 50%,transparent);
					-webkit-transform: skewX(23deg);
					-moz-transform: skewX(23deg);
					-ms-transform: skewX(23deg);
					-o-transform: skewX(23deg);
					transform: skewX(23deg);
					-webkit-box-shadow: inset 0 2px 0 -1px #fff,inset 2px 0 0 -1px #fff;
					-moz-box-shadow: inset 0 2px 0 -1px #fff,inset 2px 0 0 -1px #fff;
					box-shadow: inset 0 2px 0 -1px #fff,inset 2px 0 0 -1px #fff;
				}
				&:after {
					right: -5px;
					border-right: 1px solid #b8b2a9;
					background-image: linear-gradient(to bottom left,rgba(70,63,57,0.85),rgba(70,63,57,0.85) 50%,transparent 50%,transparent);
					-webkit-transform: skewX(-23deg);
					-moz-transform: skewX(-23deg);
					-ms-transform: skewX(-23deg);
					-o-transform: skewX(-23deg);
					transform: skewX(-23deg);
					-webkit-box-shadow: inset 0 2px 0 -1px #fff,inset -2px 0 0 -1px #fff;
					-moz-box-shadow: inset 0 2px 0 -1px #fff,inset -2px 0 0 -1px #fff;
					box-shadow: inset 0 2px 0 -1px #fff,inset -2px 0 0 -1px #fff;
				}
			}
		}
		.cropMarker {
			position: absolute;
			z-index: 2;
			margin-left: -12.5px;
			margin-top: -32px;
		}
		.cropMarker.cropAmount1 {
			background-position: -1800px -1700px;
			background-image: url("//iwstatic.g.bsrv.su/img/sprites/map.png");
			width: 25px;
			height: 32px;
		}
		.cropMarker.cropAmount2 {
			background-position: -1864px -1668px;
			background-image: url("//iwstatic.g.bsrv.su/img/sprites/map.png");
			width: 25px;
			height: 32px;
		}
		.fieldMarker {
			position: absolute;
			z-index: 5;
			width: 150px;
			margin-left: -75px;
			margin-top: -20px;
			.wrapper {
				position: absolute;
				z-index: 1;
				background-image: -owg-linear-gradient(rgba(232,229,225,0.8),#fff);
				background-image: -webkit-linear-gradient(rgba(232,229,225,0.8),#fff);
				background-image: -moz-linear-gradient(rgba(232,229,225,0.8),#fff);
				background-image: -o-linear-gradient(rgba(232,229,225,0.8),#fff);
				background-image: linear-gradient(rgba(232,229,225,0.8),#fff);
				border: 1px solid #463f39;
				-webkit-box-shadow: rgba(0,0,0,0.25) 1px 1px 5px 0;
				-moz-box-shadow: rgba(0,0,0,0.25) 1px 1px 5px 0;
				box-shadow: rgba(0,0,0,0.25) 1px 1px 5px 0;
				left: 50%;
				bottom: 0;
				transform: translateX(-50%);
				.content {
					line-height: 14px;
					font-size: 11px;
					color: $color_2;
					padding: 5px;
					text-align: center;
					word-wrap: break-word;
					.personal {
						span {
							&:last-of-type {
								color: $color_3;
							}
						}
						.playerLink {
							display: block;
							color: $color_4;
							border-bottom: 1px solid #b2b2b2;
							padding-bottom: 3px;
							margin-bottom: 2px;
							cursor: pointer;
						}
						.playerBox {
							width: 46px;
							height: 40px;
							background-image: -owg-linear-gradient(to top,#fff 5px,transparent 40px);
							background-image: -webkit-linear-gradient(to top,#fff 5px,transparent 40px);
							background-image: -moz-linear-gradient(to top,#fff 5px,transparent 40px);
							background-image: -o-linear-gradient(to top,#fff 5px,transparent 40px);
							background-image: linear-gradient(to top,#fff 5px,transparent 40px);
							position: absolute;
							overflow: hidden;
							left: calc(50% - 23px);
							top: -41px;
							.heroImage {
								top: -4px;
								left: -7px;
							}
							.heroImage.female {
								left: -9px;
							}
						}
					}
					.global {
						span {
							&:last-of-type {
								color: $color_3;
							}
						}
					}
					.prestigeStars {
						position: relative;
						background-color: $background-color_7;
						border: 1px solid #463f39;
						border-left: 0;
						width: 46px;
						height: 17px;
						margin-left: 33px;
						margin-top: -6px;
						&:before {
							content: "";
							z-index: 0;
							border-bottom: 1px solid #463f39;
							border-top: 1px solid #463f39;
							position: absolute;
							background-color: $background-color_7;
							top: -1px;
							width: 17px;
							height: 17px;
							border-left: 1px solid #463f39;
							left: -4px;
							-webkit-transform: skewX(21deg);
							-moz-transform: skewX(21deg);
							-ms-transform: skewX(21deg);
							-o-transform: skewX(21deg);
							transform: skewX(21deg);
						}
						&:after {
							content: "";
							z-index: 0;
							border-bottom: 1px solid #463f39;
							border-top: 1px solid #463f39;
							position: absolute;
							background-color: $background-color_7;
							top: -1px;
							width: 17px;
							height: 17px;
							border-right: 1px solid #463f39;
							right: -4px;
							-webkit-transform: skewX(-21deg);
							-moz-transform: skewX(-21deg);
							-ms-transform: skewX(-21deg);
							-o-transform: skewX(-21deg);
							transform: skewX(-21deg);
						}
						.prestigeStar {
							margin: 0;
							display: block;
							margin-top: 2px;
							margin-left: 2px;
							padding: 0;
							float: left;
							z-index: 1;
						}
						.prestigeBadge {
							z-index: 2;
						}
					}
				}
				.pagination {
					padding: 3px;
					font-size: 11px;
					text-align: center;
					background-color: $background-color_8;
					border-top: 1px solid #b2b2b2;
					i {
						vertical-align: middle;
					}
				}
				.closeNotification {
					display: none;
					position: absolute;
					top: -5px;
					right: -5px;
					background-color: $background-color_7;
					border: 2px solid #fff;
					-webkit-border-radius: 50%;
					-moz-border-radius: 50%;
					-ms-border-radius: 50%;
					-o-border-radius: 50%;
					border-radius: 50%;
					-webkit-box-shadow: 0 0 0 1px #b8b2a9;
					-moz-box-shadow: 0 0 0 1px #b8b2a9;
					box-shadow: 0 0 0 1px #b8b2a9;
				}
				&:hover {
					.closeNotification {
						display: block;
						&:hover {
							background-color: $background-color_9;
							border: 2px solid #e8e5e1;
							-webkit-box-shadow: 0 0 0 1px #888;
							-moz-box-shadow: 0 0 0 1px #888;
							box-shadow: 0 0 0 1px #888;
						}
					}
				}
			}
			.wrapper.fieldMarkerBox {
				width: 122px;
			}
			&:after {
				content: '';
				position: absolute;
				z-index: 2;
				top: 100%;
				left: 50%;
				border: 1px solid;
				border-color: $border-color_1;
				background-image: -owg-linear-gradient(45deg,#fff 55%,transparent 65%);
				background-image: -webkit-linear-gradient(45deg,#fff 55%,transparent 65%);
				background-image: -moz-linear-gradient(45deg,#fff 55%,transparent 65%);
				background-image: -o-linear-gradient(45deg,#fff 55%,transparent 65%);
				background-image: linear-gradient(45deg,#fff 55%,transparent 65%);
				width: 12px;
				height: 13px;
				-webkit-transform: rotate(-45deg) skew(21deg,21deg);
				-moz-transform: rotate(-45deg) skew(21deg,21deg);
				-ms-transform: rotate(-45deg) skew(21deg,21deg);
				-o-transform: rotate(-45deg) skew(21deg,21deg);
				transform: rotate(-45deg) skew(21deg,21deg);
				margin-top: -8px;
				margin-left: -7px;
			}
			&:hover {
				z-index: 6;
			}
		}
		.fieldMarker.minimizedMarker {
			z-index: 4;
			.wrapper {
				.content {
					padding: 1px;
					padding-bottom: 0;
				}
			}
			&:after {
				width: 9px;
				height: 10px;
				margin-left: -5px;
				margin-top: -6px;
				border-right: 0;
				border-top: 0;
			}
		}
		.fieldMarker.allianceWide {
			.wrapper {
				background-image: -owg-linear-gradient(rgba(232,229,225,0.8),#b1e4ff);
				background-image: -webkit-linear-gradient(rgba(232,229,225,0.8),#b1e4ff);
				background-image: -moz-linear-gradient(rgba(232,229,225,0.8),#b1e4ff);
				background-image: -o-linear-gradient(rgba(232,229,225,0.8),#b1e4ff);
				background-image: linear-gradient(rgba(232,229,225,0.8),#b1e4ff);
			}
			&:after {
				background-size: 100% auto;
				background-image: -owg-linear-gradient(45deg,#b1e4ff 55%,transparent 65%);
				background-image: -webkit-linear-gradient(45deg,#b1e4ff 55%,transparent 65%);
				background-image: -moz-linear-gradient(45deg,#b1e4ff 55%,transparent 65%);
				background-image: -o-linear-gradient(45deg,#b1e4ff 55%,transparent 65%);
				background-image: linear-gradient(45deg,#b1e4ff 55%,transparent 65%);
			}
		}
		.fieldMarker.personal {
			.wrapper {
				background-image: -owg-linear-gradient(rgba(232,229,225,0.8),#a5c400);
				background-image: -webkit-linear-gradient(rgba(232,229,225,0.8),#a5c400);
				background-image: -moz-linear-gradient(rgba(232,229,225,0.8),#a5c400);
				background-image: -o-linear-gradient(rgba(232,229,225,0.8),#a5c400);
				background-image: linear-gradient(rgba(232,229,225,0.8),#a5c400);
			}
			&:after {
				background-image: -owg-linear-gradient(45deg,#a5c400 55%,transparent 65%);
				background-image: -webkit-linear-gradient(45deg,#a5c400 55%,transparent 65%);
				background-image: -moz-linear-gradient(45deg,#a5c400 55%,transparent 65%);
				background-image: -o-linear-gradient(45deg,#a5c400 55%,transparent 65%);
				background-image: linear-gradient(45deg,#a5c400 55%,transparent 65%);
			}
		}
		.fieldMarker.hasNavigation {
			&:not(.minimizedMarker) {
				&:after {
					background-color: $background-color_8;
					background-image: -owg-none;
					background-image: -webkit-none;
					background-image: -moz-none;
					background-image: -o-none;
					background-image: none;
				}
			}
		}
		.movementSprite {
			position: absolute;
			z-index: 2;
			i {
				position: absolute;
				height: 100px;
				width: 100px;
				margin-left: -50px;
				margin-top: -65px;
			}
			i.ownType3 {
				background-image: url("//iwstatic.g.bsrv.su/img/movement/outgoingAttack_static.png");
				width: 100px;
				height: 100px;
			}
			i.ownType5 {
				background-image: url("//iwstatic.g.bsrv.su/img/movement/outgoingSupport_static.png");
				width: 100px;
				height: 100px;
			}
			i.ownAttAndDef {
				background-image: url("//iwstatic.g.bsrv.su/img/movement/outgoingSupportAndAttack_static.png");
				width: 100px;
				height: 100px;
			}
			i.enemyAttack {
				background-image: url("//iwstatic.g.bsrv.su/img/movement/incomingAttack_static.png");
				width: 100px;
				height: 100px;
			}
			i.robberAttack {
				background-image: url("//iwstatic.g.bsrv.su/img/movement/incomingRobberAttack_static.png");
				width: 100px;
				height: 100px;
			}
		}
		.fireworks {
			position: absolute;
			margin: -38px -64px;
			background-image: url("//iwstatic.g.bsrv.su/img/sprites/map.png");
			background-position: -252px -1520px;
			width: 126px;
			height: 80px;
			animation: mapFireworks 5.6s step-end infinite;
			-webkit-animation: mapFireworks 5.6s step-end infinite;
			-moz-animation: mapFireworks 5.6s step-end infinite;
		}
		.wwMist {
			position: absolute;
			background-image: url("//iwstatic.g.bsrv.su/img/map/overlay/worldWonderMist.png");
			width: 1890px;
			height: 1020px;
			transform: translate(-50%,-43%);
		}
		.clouds {
			position: absolute;
			z-index: 2;
			top: -1500px;
			left: -1970px;
			border: 1000px solid #f7fbf9;
		}
		.mainVillage {
			position: absolute;
			z-index: 2;
			margin-left: 25px;
			margin-top: -15px;
			width: 26px;
			height: 26px;
			i {
				margin: 4px 5px;
				z-index: 2;
			}
			&:after {
				content: "";
				position: absolute;
				top: 0;
				bottom: 0;
				left: 0;
				right: 0;
				width: auto;
				height: auto;
				background-color: $background-color_10;
				border: 1px solid #b8b2a9;
				-webkit-box-shadow: inset 0 0 0 1px #fff;
				-moz-box-shadow: inset 0 0 0 1px #fff;
				box-shadow: inset 0 0 0 1px #fff;
				-webkit-border-radius: 50% 50% 50% 0;
				-moz-border-radius: 50% 50% 50% 0;
				-ms-border-radius: 50% 50% 50% 0;
				-o-border-radius: 50% 50% 50% 0;
				border-radius: 50% 50% 50% 0;
				-webkit-transform: rotate(45deg);
				-moz-transform: rotate(45deg);
				-ms-transform: rotate(45deg);
				-o-transform: rotate(45deg);
				transform: rotate(45deg);
			}
		}
	}
	#overlayMarkers.zoomLevel2 {
		.movementSprite {
			i {
				-webkit-transform: scale(0.5);
				-moz-transform: scale(0.5);
				-ms-transform: scale(0.5);
				-o-transform: scale(0.5);
				transform: scale(0.5);
				margin-top: -58px;
			}
		}
		.fireworks {
			transform: scale(0.7);
		}
		.wwMist {
			transform: scale(0.5);
			transform-origin: -50% -43%;
		}
	}
	#tileInformation {
		position: absolute;
		z-index: 2;
		width: 350px;
		height: 64px;
		left: 50%;
		top: 100px;
		margin-left: -175px;
		border: 1px solid #fff;
		-webkit-box-shadow: 0 0 1px rgba(0,0,0,0.7);
		-moz-box-shadow: 0 0 1px rgba(0,0,0,0.7);
		box-shadow: 0 0 1px rgba(0,0,0,0.7);
		background-image: -owg-linear-gradient(#888 0,#ebebeb 12%,rgba(235,235,235,0.1) 100%);
		background-image: -webkit-linear-gradient(#888 0,#ebebeb 12%,rgba(235,235,235,0.1) 100%);
		background-image: -moz-linear-gradient(#888 0,#ebebeb 12%,rgba(235,235,235,0.1) 100%);
		background-image: -o-linear-gradient(#888 0,#ebebeb 12%,rgba(235,235,235,0.1) 100%);
		background-image: linear-gradient(#888 0,#ebebeb 12%,rgba(235,235,235,0.1) 100%);
		padding-top: 25px;
		i {
			margin: 0 2px;
		}
		.owner {
			.languageFlag {
				position: absolute;
				left: 11px;
				top: 5px;
				border: 1px solid #b8b2a9;
			}
			i {
				top: -2px;
			}
		}
		.contentBoxHeader {
			position: relative;
			border: 1px solid #b8b2a9;
			background-color: $background-color_3;
			margin: 0 3px;
			width: auto;
			padding: 5px 10px;
			line-height: 16px;
			.villageName {
				width: 174px;
				text-align: center;
				position: absolute;
				left: 86px;
			}
			.coordinates {
				font-weight: normal;
			}
			.mainVillageIndicator {
				float: right;
			}
			.additionalInfo {
				float: right;
			}
		}
		.contentBoxBody {
			background-color: $background-color_3;
			margin: 0 3px;
			width: auto;
			height: 33px;
			border: 1px solid #b8b2a9;
			border-top: 0;
			padding: 3px 3px;
			text-align: center;
			line-height: 26px;
			position: relative;
			.resources {
				display: inline-block;
			}
			.influenceBox {
				position: absolute;
				right: 3px;
				top: 3px;
			}
		}
		.reportsContainer {
			position: absolute;
			top: 100%;
			margin-top: -4px;
			width: 100%;
			text-align: center;
			.reportsDecoration {
				display: inline-block;
				position: relative;
				line-height: 26px;
				.inner {
					display: inline-block;
					padding: 0 5px;
					box-sizing: border-box;
					background-color: $background-color_11;
					border-top: 1px solid #b8b2a9;
					border-bottom: 1px solid #b8b2a9;
				}
				.carry {
					margin-left: 10px;
				}
				&:before {
					content: "";
					position: absolute;
					top: 0;
					box-sizing: border-box;
					border-top: 1px solid #b8b2a9;
					width: 12px;
					height: 27px;
					left: -5px;
					border-left: 1px solid #b8b2a9;
					background-image: linear-gradient(to bottom right,rgba(255,255,255,0.85),rgba(255,255,255,0.85) 50%,transparent 50%,transparent);
					-webkit-transform: skewX(23deg);
					-moz-transform: skewX(23deg);
					-ms-transform: skewX(23deg);
					-o-transform: skewX(23deg);
					transform: skewX(23deg);
				}
				&:after {
					content: "";
					position: absolute;
					top: 0;
					box-sizing: border-box;
					border-top: 1px solid #b8b2a9;
					width: 12px;
					height: 27px;
					right: -5px;
					border-right: 1px solid #b8b2a9;
					background-image: linear-gradient(to bottom left,rgba(255,255,255,0.85),rgba(255,255,255,0.85) 50%,transparent 50%,transparent);
					-webkit-transform: skewX(-23deg);
					-moz-transform: skewX(-23deg);
					-ms-transform: skewX(-23deg);
					-o-transform: skewX(-23deg);
					transform: skewX(-23deg);
				}
			}
		}
	}
	#tileInformation.coordsOnly {
		height: 32px;
	}
	.infoMovements {
		position: absolute;
		top: 125px;
		left: 50%;
		margin-left: 145px;
		z-index: 1000;
	}
}
#canvasMap {
	-ms-scroll-chaining: none;
	-ms-touch-action: none;
	touch-action: none;
}
body.withAnimations {
	#map {
		#overlayMarkers {
			.movementSprite {
				i.ownType3 {
					background-image: url("//iwstatic.g.bsrv.su/img/sprites/map.png");
					background-position: -1200px -1700px;
					width: 100px;
					height: 100px;
					animation: outgoingAttack 2.5s step-end infinite;
					-webkit-animation: outgoingAttack 2.5s step-end infinite;
					-moz-animation: outgoingAttack 2.5s step-end infinite;
				}
				i.ownType5 {
					background-image: url("//iwstatic.g.bsrv.su/img/sprites/map.png");
					background-position: 0 -1600px;
					width: 100px;
					height: 100px;
					animation: outgoingSupport 2.5s step-end infinite;
					-webkit-animation: outgoingSupport 2.5s step-end infinite;
					-moz-animation: outgoingSupport 2.5s step-end infinite;
				}
				i.ownAttAndDef {
					background-image: url("//iwstatic.g.bsrv.su/img/sprites/map.png");
					background-position: -1600px -1800px;
					width: 100px;
					height: 100px;
					animation: outgoingSupportAndAttack 2.5s step-end infinite;
					-webkit-animation: outgoingSupportAndAttack 2.5s step-end infinite;
					-moz-animation: outgoingSupportAndAttack 2.5s step-end infinite;
				}
				i.enemyAttack {
					background-image: url("//iwstatic.g.bsrv.su/img/sprites/map.png");
					background-position: -600px -1900px;
					width: 100px;
					height: 100px;
					animation: incomingAttack 4s step-end infinite;
					-webkit-animation: incomingAttack 4s step-end infinite;
					-moz-animation: incomingAttack 4s step-end infinite;
				}
				i.robberAttack {
					background-image: url("//iwstatic.g.bsrv.su/img/sprites/map.png");
					background-position: -1000px -1600px;
					width: 100px;
					height: 100px;
					animation: incomingRobberAttack 4s step-end infinite;
					-webkit-animation: incomingRobberAttack 4s step-end infinite;
					-moz-animation: incomingRobberAttack 4s step-end infinite;
				}
			}
		}
	}
}
.Firefox {
	#map {
		#overlayMarkers {
			.fireworks {
				filter: none !important;
			}
		}
	}
}
.noAnimations {
	#map {
		#overlayMarkers {
			.fireworks {
				display: none !important;
			}
		}
	}
}
html {
	&:not(.Edge) {
		.withAnimations {
			#map {
				#overlayMarkers.zoomLevel2 {
					.wwMist {
						animation: none;
						-webkit-animation: none;
						-moz-animation: none;
					}
				}
			}
		}
	}
}
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';
import WorldMap from '@/classes/game/WorldMap';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Map | IW'});
	},
	data: () => ({
		mapobj: null,
		
		moveFrom: {
			x: null,
			y: null,
		},
		zoomLevels: {
			1: {
				width: 20,
				height: 20,
			},
			2: {
				width: 30,
				height: 30,
			},
			3: {
				width: 40,
				height: 40,
			},
			//80, 55
			//60, 41
			//50, 34
			//40, 28
			//30, 21
			//20, 14
		},
		zoomLevel: 3,
		
		tiInfos: {
			coordsOnly: false,
			coord: null,
			isMainVillage: true,
			villageName: 'Оазис', //'Покинутая долина', 'Новая деревня', 'Логово разбойников I'
			playerName: 'lexinzector',
			population: 0,
			oasis: {
				oasisStatus: 'Village.OASIS_STATUS_OCCUPIED', //Village.OASIS_STATUS_OCCUPIED, Village.OASIS_STATUS_WILD
			},
			oasisBonus: {
				wood: 25,
				clay: 25,
				/*iron: 25,
				crop: 25,*/
			},
			oasisDetails: {
				filteredTroops: [
					{
						unitType: 1,
						count: 5,
					},
					{
						unitType: 2,
						count: 5,
					},
					/*{
						unitType: 3,
						count: 6,
					},
					{
						unitType: 4,
						count: 3,
					},*/
				],
			},
			resDistribution: {
				wood: 4,
				clay: 4,
				/*iron: 4,
				crop: 6,*/
			},
			robberVillageDetails: {
				filteredTroops: [
					{
						unitType: 1,
						count: 1,
					},
					{
						unitType: 2,
						count: 1,
					},
				],
			},
			country: 'ru',
		},
		nolink: 0,
		kingdomId: 1,
		kingdomName: 'Разбой',
		multiLanguageServer: true,
		
		filters: {
			showFilters: false,
		},
		goToLocation: {
			show: false,
		},
	}),
	watch: {
		zoomLevel(newVal, oldVal) {
			if (this.mapobj) {
				const zoomlvl = this.zoomLevels[newVal];
				this.mapobj.resizeCells(zoomlvl.width, zoomlvl.height);
			}
		},
	},
	computed: {
		zoomMaxLevel() {
			return Math.max(...Object.keys(this.zoomLevels).map(Number));
		},
		zoomMinLevel() {
			return Math.min(...Object.keys(this.zoomLevels).map(Number));
		},
	},
	methods: {
		async onGotoOpenIsland() {
			this.mapobj.goto(0, 0, true);
		},
		
		onZoomIn() {
			if (this.zoomLevel < Math.max(...Object.keys(this.zoomLevels).map(Number))) {
				this.zoomLevel++;
			}
		},
		onZoomOut() {
			if (this.zoomLevel > Math.min(...Object.keys(this.zoomLevels).map(Number))) {
				this.zoomLevel--;
			}
		},
		
		onWindowResize(){
			this.mapobj._resize(
				document.querySelector('.map-container').clientWidth,
				document.querySelector('.map-container').clientHeight
			);
		},
	},
	created(){
		this.gameModel.buildingQueueShow = false;
	},
	async mounted(){
		const zoomlvl = this.zoomLevels[this.zoomLevel];
		this.mapobj = new WorldMap.Core(
			document.querySelector('.map-container').clientWidth,
			document.querySelector('.map-container').clientHeight,
			0, 0,
			zoomlvl.width, zoomlvl.height,
			{
				getmap_api_url: '/api/mapdataadm',
				deselectable: true,
				img_types: {
					empty: 'admin/sea_empty.png',
					free: 'admin/sea_free.png',
					island1: 'admin/island1.png',
					island1_left: 'admin/island1_left.png',
					bonus1: 'admin/island1.png',
					bonus1_left: 'admin/island1_left.png',
				},
				cellMarker: {
					topleft: {
						show: [],
					},
				},
			}
		);
		this.mapobj.addEventListener('select', async (data) => {
			console.log(data);
			//console.log(map._data[data.x][data.y]);
			//this.tiInfos.coord.x = data.x;
			//this.tiInfos.coord.y = data.y;
			if (this.moveFrom.x == null && this.moveFrom.y == null) {
				let mapelem = this.mapobj.getCell(data.x, data.y)?.data;
				if (mapelem?.idIsland != null) {
					this.moveFrom.x = data.x;
					this.moveFrom.y = data.y;
				}
			} else if (this.moveFrom.x != data.x || this.moveFrom.y != data.y) {
				let mapelem = this.mapobj.getCell(data.x, data.y)?.data;
				if (mapelem?.idIsland == null && mapelem?.idUser == null) {
					if (confirm(`Переместить ${this.moveFrom.x} | ${this.moveFrom.y} в ${data.x} | ${data.y}?`)) {
						const ret = await this.gameModel.worldmap.moveAdmItem({
							x1: this.moveFrom.x,
							y1: this.moveFrom.y,
							x2: data.x,
							y2: data.y,
						});
						if (ret.success) {
							this.mapobj.reloadCell(this.moveFrom.x, this.moveFrom.y);
							this.mapobj.reloadCell(data.x, data.y);
						} else {
							console.error(ret.error);
						}
						this.moveFrom.x = null;
						this.moveFrom.y = null;
						this.mapobj.deselect();
					} else {
						this.mapobj.select(this.moveFrom.x, this.moveFrom.y);
					}
				}
			}
		});
		this.mapobj.addEventListener('deselect', (data) => {
			//console.log(data);
			this.moveFrom.x = null;
			this.moveFrom.y = null;
		});
		/*this.mapobj.addEventListener('click', (data) => {
			//console.log(data);
		});*/
		this.mapobj.addEventListener('scroll', (direction) => {
			//console.log('scroll', direction);
			if (direction === 'up') {
				this.onZoomIn();
			} else if (direction === 'down') {
				this.onZoomOut();
			}
		});
		this.mapobj.addEventListener('focus', (data) => {
			//console.log('focus');
			//console.log(data);
			let mapelem = this.mapobj.getCell(data?.x, data?.y)?.data;
			
			this.tiInfos.coord = data;
			this.tiInfos.villageName = mapelem?.name;
			this.tiInfos.playerName = mapelem?.username;
		});
		/*this.mapobj.addEventListener('drag', () => {
			console.log('drag');
		});*/
		window.addEventListener('resize', this.onWindowResize);
	},
	beforeUnmount(){
		window.removeEventListener('resize', this.onWindowResize);
		this.mapobj.destroy();
	},
	components: {},
}
</script>
